import { getAuth } from "firebase/auth";
import { remove, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { db, signInWithGoogle } from "../../perms";

function RemoveAccount() {
  const [user, setUser] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    getAuth().onAuthStateChanged((user) => {
      setUser(user);
      if (user != null) {
        const tasksRef = ref(db, "accs/" + user.uid);
        remove(tasksRef).then(() => {
          setMessage(`Профіль ${user.displayName} видалено з додатка.`);
          user.delete();
        });
      }
    });
  }, []);
  return (
    <div className="App">
      <header className="App-header">
        <h1>UZTrains</h1>
        <p>
          <code>Надішліть запит на видалення профіля</code>
        </p>
        <div>
          <button className="button" onClick={signInWithGoogle}>
            <i className="fab fa-google"></i>Увійти за допомогою Google
          </button>
        </div>
        <p>
          <code>
            Після входу, автоматично і безповоротно видаляться всі дані
            пов'язані з вашим профілем
          </code>
        </p>
        <div>
          <code>{message}</code>
        </div>
      </header>
    </div>
  );
}

export default RemoveAccount;
